export enum FlowPurpose {
    LOGIN = 'LOGIN',
    OIDC = 'OIDC',
    CONSENT = 'CONSENT',
    PASSWORD_RECOVERY = 'PASSWORD_RECOVERY',
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
}
